export enum Permission {
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  HIDDEN = 'HIDDEN',
  VIEW = 'VIEW',
}
